// extracted by mini-css-extract-plugin
module.exports = {"Component":"DataTableRevenue_Component__3zuwZ"};